import './Footer.css'

const Footer = () => {

    return (

        <footer>Developed by Helena Sánchez</footer>
    )
}

export default Footer